export default __webpack_public_path__ + "static/media/cloudy.755396fe.svg";